<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>ID</label>
          <input type="text" readonly class="form-control" :value="control.name" @blur="editSidebar" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Control type</label>
          <input type="text" readonly class="form-control" :value="typeFirstUpper" @blur="editSidebar" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'fieldName',
              $parent.backToDefault
            ]"
          >Name</label>
          <input
            type="text"
            class="form-control"
            v-model="control.fieldName"
            data-toggle="tooltip"
            @blur="editSidebar"
            title="Field Name must be UNIQUE in Section!"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'className',
              $parent.backToDefault
            ]"
          >Width</label>
          <select class="form-control" v-model="control.className" @change="editSidebar">
            <option v-for="(label, value) in widthOptions" :value="value">{{label}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'vif',
              $parent.backToDefault
            ]"
          >Show If</label>
          <input type="text" class="form-control" v-model="control.vif" @blur="editSidebar" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>
            <input
              type="checkbox"
              name="isInvisible" 
              v-model="control.invisible"
              @change="() => { toggleInvisibleFlag();editSidebar() }"
            />
            <span>Invisible?</span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <label>
          <input type="checkbox" name="isRequired" v-model="control.required" @change="editSidebar" />
          <span
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'required',
              $parent.backToDefault
            ]"
          />
          <span>Required?</span>
        </label>

        <label>
          <input type="checkbox" name="isReadonly" v-model="control.readonly" @change="editSidebar" />
          <span
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'readonly',
              $parent.backToDefault
            ]"
          />
          <span>Readonly?</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { FORM_CONSTANTS } from '@/components/DataGrid/FormBuilder/config/constants'

import { cloneDeep, findIndex } from 'lodash'
// services
import db from '@/services/db'

export default {
  name: 'BaseConfigComponent',
  props: {
    control: {
      type: Object,
    },
    editSidebar: {
      type: Function,
    }
  },
  data: () => ({
    widthOptions: FORM_CONSTANTS.WidthOptions,
  }),
  computed: {
    typeFirstUpper() {
      return (
        this.control.type.charAt(0).toUpperCase() + this.control.type.slice(1)
      )
    },
  },
  methods: {
    toggleInvisibleFlag() {
      const fbInst = this.$instByClass(this, 'form-builder-root')
      const gridId = fbInst.gridId
      const cellKey = this.control.propName
      const view = fbInst.view
      const form = cloneDeep(fbInst.form)
      const value = this.control.invisible ? true : false

      const data = {
        gridId,
        cellKey,
        view,
        value,
        form
      }

      for (let section of form.sections || []) {
        for (let row of section.rows || []) {
          const idx = findIndex(row.controls || [], { propName: cellKey })

          if (idx) {
            row.controls[idx].invisible = value

            break
          }
        }
      }

      const modalInst = this.$instByClass(this, 'editFormDataModal')

      modalInst.formData = form

      db.dataGrid.options.changeColumnVisability(data)
    },
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip() // trigger tooltip
  },
}
</script>

<style scoped>
</style>
